module.exports = __webpack_public_path__ + "static/7-b674f58f1f5239d891c7d51e0f7accf9.jpg";